module.exports = __webpack_public_path__ + "static/media/Used Cat Wheel Loaders - Toromont Cat.12cb1781.jpg";